const bindEvents = function () {
  let productDescritpionControls =  document.querySelector('.js-product-description-controls');
  if (productDescritpionControls) {
    productDescritpionControls.addEventListener('click', function(){
      const toggle = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !toggle);
      if(!toggle) {
        document.querySelector('.product-description-box').classList.add('opened-text')
      } else {
        document.querySelector('.product-description-box').classList.remove('opened-text')
      }
    });
  }
}

const hideOrShowReadMore = () => {
  const descriptionBoxHeight = document.querySelector('.product-description-box').clientHeight;
  const descriptionTextHeight = document.querySelector('.product-description-content').clientHeight;
  if(descriptionBoxHeight >= descriptionTextHeight) {
    document.querySelector('.product-description-controls').classList.add('d-none');
  }
}

module.exports = {
  bindEvents: bindEvents,
  hideOrShowReadMore: hideOrShowReadMore
}